import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './TooltipMetricTextForecast.module.scss';

export const ClientVisitsCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.clientVisits.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientVisits.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientVisits.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientVisits.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientVisits.rule4')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientVisits.rule5')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientVisits.rule6')}</span>
  </div>
);

export const NewClientsCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.newClients.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.newClients.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.newClients.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.newClients.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.newClients.rule4')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.newClients.rule5')}</span>
  </div>
);

export const NcobCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.ncobCount.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.ncobCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.ncobCount.rule2')}</span>
  </div>
);

export const CanceledCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.canceledCount.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.canceledCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.canceledCount.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.canceledCount.rule3')}</span>
  </div>
);

export const NoShowCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.noShowCount.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.noShowCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.noShowCount.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.noShowCount.rule3')}</span>
  </div>
);

export const NoShowAndCanceledCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.noShowAndCanceledCount.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.noShowAndCanceledCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.noShowAndCanceledCount.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.noShowAndCanceledCount.rule3')}</span>
  </div>
);

export const BookableSlots = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.bookableSlots.description')}
    {t('composite.tooltipKpisMetrics.bookableSlots.eg')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.bookableSlots.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.bookableSlots.rule2')}</span>
    {t('composite.tooltipKpisMetrics.bookableSlots.rule3')}
  </div>
);

export const ClientRequests = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.clientRequests.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientRequests.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientRequests.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.clientRequests.rule3')}</span>
  </div>
);

export const ClientVisitFrequency = ({ t }) => (
  <div className={CN.component}>{t('composite.tooltipKpisMetrics.clientVisitFrequency.description')}</div>
);

export const NumberOfDaysOff = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.numberOfDaysOff.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetrics.numberOfDaysOff.rule1')}</div>
  </div>
);

export const OccupancyPct = ({ t }) => (
  <div className={CN.component}>
    <span></span>
    {t('composite.tooltipKpisMetrics.occupancyPct.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.occupancyPct.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.occupancyPct.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.occupancyPct.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetrics.occupancyPct.rule4')}</span>
  </div>
);

export const NcobPct = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.ncobPct.description')}
    {t('composite.tooltipKpisMetrics.ncobPct.description2')}
  </div>
);

export const ColorPercentage = ({ t }) => (
  <div className={CN.component}>{t('composite.tooltipKpisMetrics.colorPercentage.description')}</div>
);

export const NcobValue = ({ t }) => (
  <div className={CN.component}>{t('composite.tooltipKpisMetrics.ncobValue.description')}</div>
);

export const NoShowValue = ({ t }) => (
  <div className={CN.component}>{t('composite.tooltipKpisMetrics.noShowValue.description')}</div>
);

export const CanceledValue = ({ t }) => (
  <div className={CN.component}>{t('composite.tooltipKpisMetrics.canceledValue.description')}</div>
);

export const NoShowAndCanceledValue = ({ t }) => (
  <div className={CN.component}>{t('composite.tooltipKpisMetrics.noShowAndCanceledValue.description')}</div>
);

export const BookableSlotsValue = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetrics.bookableSlotsValue.description')}
    <span></span>
    <div>
      {t('composite.tooltipKpisMetrics.bookableSlotsValue.rule1')} <CurrencySign value={45} />
    </div>
  </div>
);

export const TooltipMetricTexts = ({ metric }) => {
  const { t } = useTranslation();

  switch (metric) {
    case 'client_visits_count':
      return <ClientVisitsCount t={t} />;
    case 'new_clients_count':
      return <NewClientsCount t={t} />;
    case 'ncob_count':
      return <NcobCount t={t} />;
    case 'canceled_count':
      return <CanceledCount t={t} />;
    case 'no_show_count':
      return <NoShowCount t={t} />;
    case 'no_show_and_canceled_count':
      return <NoShowAndCanceledCount t={t} />;
    case 'bookable_slots':
      return <BookableSlots t={t} />;
    case 'client_requests':
      return <ClientRequests t={t} />;
    case 'client_visit_frequency':
      return <ClientVisitFrequency t={t} />;
    case 'number_of_days_off':
      return <NumberOfDaysOff t={t} />;
    case 'occupancy_pct':
      return <OccupancyPct t={t} />;
    case 'ncob_value':
      return <NcobValue t={t} />;
    case 'no_show_value':
      return <NoShowValue t={t} />;
    case 'canceled_value':
      return <CanceledValue t={t} />;
    case 'no_show_and_canceled_value':
      return <NoShowAndCanceledValue t={t} />;
    case 'bookable_slots_value':
      return <BookableSlotsValue t={t} />;
    default:
      return null;
  }
};
